module.exports = __webpack_public_path__ + "img/Pedro-Luis-Alonso-Tuda.716f0b61.png";